import { DownloadZipButton } from '@main/pc-core-components';
import type { DownloadZipProps } from '@main/privacy-center/src/hooks';
import { ID } from '@main/schema-utils';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectRequiredPrivacyCenter } from '../App/selectors';

interface DownloadRequestProps extends DownloadZipProps {
  /** The HTML report to show */
  report: string;
  /** The name of the download zip */
  zipFileName: string;
  /** The ID of the request to download zip for */
  requestId: ID<'request'>;
}
/**
 * Allow the user to download their data
 */
export const DownloadRequest: React.FC<
  React.PropsWithChildren<DownloadRequestProps>
> = ({ downloadZip, downloadStatus, report, requestId, zipFileName }) => {
  const { transformAccessReportJsonToCsv } = useSelector(
    selectRequiredPrivacyCenter,
  );
  const status = useMemo(
    () =>
      downloadStatus[requestId] ?? {
        progress: 0,
        isDownloading: false,
      },
    [downloadStatus[requestId]],
  );
  return (
    <DownloadZipButton
      onClick={() =>
        downloadZip(requestId, {
          report,
          zipFileName,
          convertJSONtoCSV: transformAccessReportJsonToCsv,
        })
      }
      {...status}
    />
  );
};

export default DownloadRequest;
